export const CROA_CLAIMS_PATH = "croa-claims";
export const FDCPA_VIOLATIONS_PATH = "fdcpa-violations";
export const PERSONAL_INJURY_PATH = "personal-injury";
export const EMPLOYMENT_LAW_PATH = "employment-law";

export const AR_SITE_CONFIGURATION = {
	[CROA_CLAIMS_PATH]: {},
	[FDCPA_VIOLATIONS_PATH]: {},
	[PERSONAL_INJURY_PATH]: {},
	[EMPLOYMENT_LAW_PATH]: {},
};
